/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
export const strings = {
    removeTaskSubtitle: 'Delete Task',
    cancelNewTaskSubtitle: 'Cancel',
    newTaskPlaceholder: 'Adding task...',
    addTaskButtonSubtitle: 'Add'
};
//# sourceMappingURL=strings.js.map